export default __webpack_public_path__ + "static/media/klima-on.2cf37beb.gif";